import React from 'react'
import PropTypes from 'prop-types'

import { useLocation } from 'react-router-dom'

import TabContext from 'contexts/TabContext'

const TabProvider = ({ defaultValue, children }) => {
  const location = useLocation()
  const [state, setState] = React.useState({
    current: (location.state && location.state.tab) || defaultValue,
  })

  const handleChange = (event, newValue) => {
    setState({ ...state, current: newValue })
  }

  return (
    <TabContext.Provider value={{ state, change: handleChange }}>
      {children}
    </TabContext.Provider>
  )
}

TabProvider.propTypes = {
  children: PropTypes.node,
}

export default TabProvider
